import {Alert} from 'react-bootstrap'
import {DeactivateAccount} from '../../../../modules/accounts/components/settings/cards/DeactivateAccount'
import {IAllUserNode} from '../../../types/users'
import {ProfileDetailsSetting} from './ProfileDetailsSetting'
import {ChangePassword} from './ChangePassword'
import {ForcePasswordChangeCard} from './ForcePasswordChangeCard'
import {FormattedMessage} from 'react-intl'
import {ONE_USER_MESSAGES as M} from '../oneUserMessages'

interface ISettingProps {
  node: IAllUserNode
  refetch: () => void
  setTabs: (TTabsOneUser) => void
}

export const SettingsTab: React.FC<ISettingProps> = ({node, refetch}) => {
  return (
    <>
      <ProfileDetailsSetting node={node} refetch={refetch} />
      <Alert variant='danger' className='my-5'>
        <Alert.Heading className='d-flex flex-center gap-2'>
          <i className='bi bi-exclamation-triangle fs-1' style={{color: 'inherit'}} />
          <FormattedMessage {...M.dangerousZone} />
        </Alert.Heading>
      </Alert>
      <ChangePassword id={node.id} refetch={refetch} />
      <ForcePasswordChangeCard
        userId={node.id}
        forcePasswordChange={node.forcePasswordChange}
        twoFactorEnabled={node.twoFactorEnabled}
        twoFactorRequired={node.twoFactorRequired}
        twoFactorEmailFallbackEnabled={node.twoFactorEmailFallbackEnabled}
        passkeyCredentials={node.passkeyCredentials}
        onUpdated={refetch}
      />
      <DeactivateAccount userId={node.id} isActive={node.isActive} onStatusChanged={refetch} />
    </>
  )
}
